import { hasBannedCharacters } from '../../lib/validation/text_validation';

/**
 * Validates a replication ID string by ensuring it is non-empty and does not contain banned characters.
 * @param {string} group_id The replication ID string to validate.
 * @returns {boolean} `true` if the replication ID is valid, `false` otherwise.
 */
export const isValidReplicationId = (replication_id: unknown): boolean =>
  typeof replication_id === 'string' &&
  !!(
    replication_id &&
    !hasBannedCharacters(replication_id, {
      banned_characters: "0123456789- .()'&$+%@"
    })
  );

/**
 * Validates a table ID string by ensuring it is non-empty and does not contain banned characters.
 * @param {string} group_id The table ID string to validate.
 * @returns {boolean} `true` if the table ID is valid, `false` otherwise.
 */
export const isValidTableId = (table_id: unknown): boolean =>
  typeof table_id === 'string' &&
  !!(
    table_id &&
    !hasBannedCharacters(table_id, {
      banned_characters: "0123456789- .()'&$+%@"
    })
  );
